import { CstCustPhone } from './cstCustPhone'

export class PhoneDTO {
	cstCustPhone: CstCustPhone
	phoneSeq: string;
	areaCode: string;
	extension: string;
	phoneNum: string="";
	phoneTypcode: string;
	primaryFlag: boolean;
	effectiveDate: string;
	expiryDate: string;
	validFlag: true;
	validationErrors: string;
	contactFlag: false;
	createDate: string;
	createUser: string;
	updateDate: string;
	updateUser: string;
	activeFlag: boolean;
	label: string;
	contactPref: string;
	sortOrder: string;
	description: string

	constructor() {
		this.cstCustPhone = new CstCustPhone();
	}
}
